import router from '@/router'

import {
  saveData
} from '@/api/local_storage'

import {
  login
} from '@/api/oli_api'

const state = {
  logined: 0,
  userId: null,
  userInfo: {},
  userData: {},
  loginFor: null
}

const getters = {
  logined: state => state.logined,
  userId: state => state.userId,
  userInfo: state => state.userInfo,
  userData: state => state.userData,
  loginFor: state => state.loginFor
}

const actions = {
  login ({ getters, dispatch }) {
    let parm = {
      USER_ACCOUNT: getters.userInfo['USER_ACCOUNT'],
      PWD: getters.userInfo['PWD']
    }
    login(parm).then((data) => {
      if (data.code === 1) {
        dispatch('setLoginData', {data, save: true})
      } else {
        dispatch('logOut')
        if (getters.userInfo['USER_ACCOUNT']) {
          router.push({name: 'login'})
        }
      }
    }).catch((e) => {
      dispatch('logOut')
      router.push({name: 'login'})
    })
  },
  setLogined ({ commit }, data) {
    commit('setLogined', data)
  },
  setUserId ({ commit }, data) {
    commit('setUserId', data)
  },
  setUserInfo ({ commit }, data) {
    commit('setUserInfo', data)
  },
  setUserData ({ commit, dispatch }, data) {
    commit('setUserData', data)
    dispatch('setCanChoosePSZXs', data['PSZXs'] || [])
  },
  setLoginFor ({ commit }, data) {
    commit('setLoginFor', data)
  },
  logOut ({ dispatch }) {
    dispatch('setLogined', 0)
    dispatch('setUserId', null)
    dispatch('setUserInfo', {})
    dispatch('setUserData', {})
    saveData({key: 'loginInfo', data: {}})
  },
  setLoginData ({ dispatch }, {data, save}) {
    if (data && data['userInfo'] && data['userInfo']['USER_ID']) {
      dispatch('setUserInfo', data['userInfo'])
      dispatch('setUserData', data['datas'])
      dispatch('setUserId', data['userInfo']['USER_ID'])
      dispatch('setLogined', 1)
    } else {
      dispatch('logOut')
    }
    if (save) {
      saveData({key: 'loginInfo', data: data})
    }
  }
}

const mutations = {
  setLogined (state, data) {
    state.logined = data
  },
  setUserId (state, data) {
    state.userId = data
  },
  setUserInfo (state, data) {
    state.userInfo = data
  },
  setUserData (state, data) {
    state.userData = data
  },
  setLoginFor (state, data) {
    state.loginFor = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user_info.js